import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldCheck } from "lucide-react";

export default function CTASection({ t, navigate }) {
  return (
    <section className="py-20 bg-gray-900" data-testid="cta-section">
      <div className="max-w-4xl mx-auto px-4 text-center space-y-6">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-white">{t.cta.title}</h2>
        {t.cta.subtitle && <p className="text-gray-400 text-base">{t.cta.subtitle}</p>}
        <Button onClick={() => navigate("/login")} className="h-14 px-10 bg-[#CC0000] hover:bg-[#a30000] text-white font-bold text-base uppercase tracking-wide rounded-lg" data-testid="cta-trial-btn">
          {t.cta.btn} <ArrowRight className="w-5 h-5 ml-2" />
        </Button>
        {t.cta.urgency && (
          <p className="text-sm font-semibold text-[#CDA34F] uppercase tracking-wide">{t.cta.urgency}</p>
        )}
        <div className="flex items-center justify-center gap-2 text-sm">
          <ShieldCheck className="w-4 h-4 text-green-400" />
          <span className="text-green-400 font-medium">{t.hero.noCc}</span>
        </div>
      </div>
    </section>
  );
}
